/**
 * @file report页
 * @author fengfaxia(fengfaxia@baidu.com))
 * Copyright (c) 2018-09-26 Baidu
 */

import React from 'react';
import echarts from 'echarts';
import _ from 'lodash';
import {Modal} from 'antd';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';

import api from '../../config';
import {simMetricLine} from './simMetricLine';
// import {getLoginUrl} from '../../common/util';
import './index.less';

class Report extends React.Component {
    chartList = {}
    state = {
        registerTotalCount: '',
        visible: false
    }
    componentWillMount() {
        this.renderChart();
        this.renderRegisterTotalCount();
    }
    componentDidMount() {
        let chartList = this.chartList;
        $(window).on('resize', function () {
            _.each(chartList, chart => {
                chart.resize();
            });
        });
    }
    renderRegisterTotalCount() {
        api.getRegisterTotal().then(data => {
            this.setState({
                registerTotalCount: data.TotalCnt || 0
            });
        }).catch(() => {
            this.showModal();
        });
    }
    renderChart() {
        api.getRegisterData().then(data => {
            this.renderRegisterData(data);
        }).catch(() => {
            this.showModal();
        });

        api.getRedirectData().then(data => {
            this.renderRedirectData(data);
        }).catch(() => {
            this.showModal();
        });
    }
    renderRegisterData(registerData) {
        let createChart = echarts.init(document.getElementById('register-chart'));
        this.chartList.registerChart = createChart;
        const option = simMetricLine(registerData, '缩短网址数');
        createChart.setOption(option);
    }
    renderRedirectData(redirectData) {
        let queryChart = echarts.init(document.getElementById('redirect-chart'));

        this.chartList.redirectChart = queryChart;
        const option = simMetricLine(redirectData, '短网址跳转数');
        queryChart.setOption(option);
    }
    hideModal() {
        this.setState({
            visible: false
        });
    }
    showModal() {
        this.setState({
            visible: true
        });
    }
    goLogin() {
        /* eslint-disable */
        _hmt.push(['_trackEvent', '登录框提示', 'loginguide_click_contiue', '点击前往登录']);
        this.setState({
            visible: false
        });
        window.open('https://console.bce.baidu.com/dwz/?channel=portal', '_blank');
        // window.location.href = getLoginUrl();
    }
    render() {
        return (
            <div className="container report-container">
                <h2 className="title">数据报表</h2>
                <span>累计缩短网址总数：{this.state.registerTotalCount}</span>
                <div className="chart-container">
                    <div className="chart" id="register-chart">
                    </div>
                    <div className="chart" id="redirect-chart">
                    </div>
                </div>
                <p className="report-tip">注：数据报表不包含当天数据</p>
                {/* <p><Link to="/console/advanced_report">查看高级报表说明文档</Link></p> */}
                <Modal
                    title="登录提示"
                    visible={this.state.visible}
                    onOk={() => this.goLogin()}
                    onCancel={() => this.hideModal()}
                    okText="前往登录"
                    cancelText="取消">
                    为了保证您的网址安全，并提供更强大的个性化功能，请登录后继续使用百度短网址。谢谢您的支持！
                </Modal>
            </div>
        );
    }
}

export default connect(state => ({
    userName: state.userName,
}))(Report);
